/**
 * NOTE: This shared directory should only include utilities, models, pipes, services, guards, etc.
 * that are used both internally within this library AND externally by other libraries/apps.
 * If something is only used within a specific feature or component, scope it to that feature's
 * folder instead of adding it here. This keeps the shared directory focused and prevents it from
 * becoming a catch-all that pollutes the root-level exports.
 */
/**
 * NOTE: Barrel exports can be fragile and may cause tree-shaking issues.
 * Consider importing directly from specific subdirectories (e.g., `@lib/vehicle-intelligence/shared/pipes`)
 * instead of from this barrel file. Subdirectory index files use explicit named exports, which are
 * more reliable and better for bundle optimization.
 */
export * from './models';
export * from './pipes';
export * from './directives';
export * from './services';
export * from './guards';
